import { render, staticRenderFns } from "./ShortCite.vue?vue&type=template&id=58d32d48&scoped=true&"
import script from "./ShortCite.vue?vue&type=script&lang=js&"
export * from "./ShortCite.vue?vue&type=script&lang=js&"
import style0 from "./ShortCite.vue?vue&type=style&index=0&id=58d32d48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d32d48",
  null
  
)

export default component.exports